import StvSelbstbeteiligung from "./StvSelbstbeteiligung";
import StvVersicherungssumme from "./StvVersicherungssumme";
import StvZahlungsweise from "./StvZahlungsweise";

export default class FormAngebotDto {
    zahlungsweise?: StvZahlungsweise;

    selbstbehalt?: StvSelbstbeteiligung;

    vs?: StvVersicherungssumme;

    produktMitSchutzbrief?: boolean;

}